import { StorageKeys } from 'common/storage/constants';
import React, { useCallback } from 'react';
import { TrialShefBadge } from 'src/shared/design-system/Badge';
import { Modal } from 'src/shared/design-system/Modal';
import { useModal } from 'src/shared/hooks/useModal';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';
import { ShefImage } from '../../components/ShefImage';
import { CallToActionButton, Content } from './content-styles';

const SHEF_IMAGE_SIZE = 16 * 7;

const ShefImageContainer = styled.div`
  position: relative;
  margin: ${Spacing.NONE} ${Spacing.NONE} ${Spacing.SINGLE} ${Spacing.NONE};
`;

const BadgeContainer = styled.div`
  position: absolute;
  left: ${Spacing.NONE};
  right: ${Spacing.NONE};
  margin: auto ${Spacing.NONE};
  bottom: -${Spacing.HALF};
  text-align: center;
`;

const Header = styled.p`
  margin: 0;

  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.NORMAL};

  font-size: ${Font.Size.L};
  line-height: ${Font.LineHeight.L};

  margin: ${Spacing.NONE} ${Spacing.NONE} ${Spacing.SINGLE} ${Spacing.NONE};
`;

const Spacer = styled.div`
  align-self: flex-start;
  background-color: ${Colors.RADISH};

  height: 3px;
  width: ${Spacing.DOUBLE_HALF};

  margin: ${Spacing.NONE} ${Spacing.NONE} ${Spacing.SINGLE} ${Spacing.NONE};
`;

const Body = styled.p`
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.NORMAL};

  font-size: ${Font.Size.S};
  line-height: ${Font.LineHeight.S};

  margin: ${Spacing.NONE} ${Spacing.NONE} ${Spacing.SINGLE_HALF} ${Spacing.NONE};
`;

interface ITrialShefModalProps {
  onHide: () => void;
  shefImageUrl?: string | null;
}

export const TrialShefModal: React.FC<ITrialShefModalProps> = ({ onHide, shefImageUrl }) => {
  const { isShowing, hide } = useModal({
    defaultShow: true,
    persistentStorageKey: StorageKeys.TASTE_TESTER_MODAL,
  });

  const hideModal = useCallback(() => {
    hide();
    onHide();
  }, [hide, onHide]);

  return (
    <Modal onClose={hideModal} isShowing={isShowing}>
      <Content>
        {shefImageUrl && (
          <ShefImageContainer>
            <ShefImage src={shefImageUrl} alt='Shef image' width={SHEF_IMAGE_SIZE} />
            <BadgeContainer>
              <TrialShefBadge outline />
            </BadgeContainer>
          </ShefImageContainer>
        )}
        <Header>Order From A Trial Shef And Recieve A $15 Discount!</Header>
        <Spacer />
        <Body>
          Trial shefs are working to make a name for themelves on the platform. Help them out by writing a review of one
          of their dishes and get $15 off on your next order!
        </Body>
        <CallToActionButton onClick={onHide}>Close</CallToActionButton>
      </Content>
    </Modal>
  );
};
